import Recipient from "~/models/notifications/recipient";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import Form from "../../../formability/form_builder/models/form";
import ObjectModel from "~/models/objectModel";
import BuilderModel from "~/models/tracked/builderModel";

export default class ObjectModelTriggerRecipient extends Recipient{
  rootModel: BuilderModel;

  get rootName(): string {
    return 'object_model_trigger_recipients';
  }

}